var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7897 2.5C10.1061 2.5 10.3677 2.73501 10.4091 3.04007L10.4148 3.12487L10.4158 9.16667H16.4601C16.8053 9.16667 17.0851 9.44649 17.0851 9.79167C17.0851 10.1081 16.8499 10.3696 16.5449 10.411L16.4601 10.4167H10.4158L10.4175 16.4576C10.4176 16.8028 10.1378 17.0827 9.79266 17.0827C9.47625 17.0827 9.21471 16.8477 9.17326 16.5427L9.16754 16.4578L9.16583 10.4167H3.125C2.77982 10.4167 2.5 10.1368 2.5 9.79167C2.5 9.47525 2.73513 9.21376 3.04019 9.17237L3.125 9.16667H9.16583L9.16483 3.12513C9.16476 2.77995 9.44452 2.5 9.7897 2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5ab1aa5af226a3002f68cd4a54b7987c.svg";
export { ForwardRef as ReactComponent };